import { useState } from "react";
import { visionURL } from "../../../config/environment";
import Jsona from "jsona";
import JsonApiService from "../../../services/jsonapiService";

const dataFormatter = new Jsona();

const itemsApiService = async () =>
  new JsonApiService("items", {
    baseUrl: `${visionURL}/learning_center/api/content_repository`,
    credentials: "include"
  });

export const useItems = () => {
  const [isFetching, setIsFetching] = useState(false);

  const findItem = async ({ id, include }) => {
    setIsFetching(true);
    const service = await itemsApiService();
    const response = await service
      .include(include)
      .find(id)
      .then(response => response.json());
    setIsFetching(false);
    if (response.errors) {
      throw response.errors;
    } else {
      return dataFormatter.deserialize(response);
    }
  };

  return {
    findItem,
    isFetching
  };
};
